import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { Api } from './api';
import { Measure } from '../models/measure';

@Injectable()
export class MeasureService {
  private endpoint: string = 'measures';

  constructor(private api: Api) {
  }

  splitArray(chunksize, array) : Measure[][]{
    var arraytoReturn = [];
    for (var i =0; i< array.length; i+=chunksize){
      arraytoReturn.push(array.slice(i, i+chunksize));
    }
    return arraytoReturn;
  }

  saveAllMeasures(measures: Measure[]): Observable<any> {
    measures = measures.map(measure => {
      measure.centralPart = measure.centralPart;
      measure.height = measure.height ;
      measure.length = measure.length ;
      measure.wing2 = measure.wing2 ;
      return measure;
    });
    let saveMeasureRequests: Observable<any>[] = [];
    let measureArrayToSend = this.splitArray(100,measures);
    measureArrayToSend.forEach(measureArray=> {
      saveMeasureRequests.push(this.api.put(this.endpoint+"/allMeasures", measureArray)
        .map(res => res.json()))
    });
    return Observable.forkJoin(saveMeasureRequests);
  }

  getMeasuresLastUpdate(): Observable<string> {
    return this.api.get(this.endpoint + '/maxDate')
      .map(res => res.text() ? res.json() : null)
      .catch((error: any) => Observable.throw(error) || 'Server error');
  }

  launchComputeOnInsertedMeasure() : void {
    this.api.put(this.endpoint+"/toCompute", null).subscribe();
  }

  getToComputeIsRunning() : Observable<boolean> {
    return this.api.get(this.endpoint + '/checkCompute', null)
      .map(res => res.text() ? res.json() : null)
      .catch((error: any) => Observable.throw(error) || 'Server error');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/measure.service.ts